import { HStack, Switch, Text } from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import Pathicon from "@pathwright/features/src/modules/pathicon/Pathicon"
import { useFormikContext } from "formik"

function SwitchField({
  option
}: {
  option: {
    field: string
    label: string
    icon?: IconName
  }
}) {
  const form = useFormikContext<any>()

  return (
    <Switch.Root
      name={option.field}
      id={option.field}
      colorPalette="brand"
      checked={form.values[option.field as keyof typeof form.values]}
      onCheckedChange={async (e) => {
        await form.setFieldValue(option.field, e.checked)
        await form.submitForm()
      }}
      m={0}
      w="100%"
      cursor="pointer"
      _hover={{
        textDecoration: "none",
        bg: "blackAlpha.200",
        borderRadius: "20px"
      }}
      p={2}
    >
      <Switch.HiddenInput />
      <HStack align="center" justify="space-between" w="100%" color="gray.500">
        <Switch.Label w="100%">
          <HStack align="center">
            {!!option.icon && <Pathicon icon={option.icon} />}
            <Text fontSize="xs" my={0} fontWeight="normal">
              {option.label}
            </Text>
          </HStack>
        </Switch.Label>
        <Switch.Control>
          <Switch.Thumb />
        </Switch.Control>
      </HStack>
    </Switch.Root>
  )
}

export default SwitchField
